<!--

https://vuejs.org/v2/guide/transitions.html#List-Transitions

————————————————————————————————————————————————————————————————————————————————
—                                 TEMPLATE                                     —
————————————————————————————————————————————————————————————————————————————————
-->
<template>
  <div id="list-transition">
    <h1>{{ title }}</h1>
    <div class="row">
      <div class="col-6">
        <button v-on:click="add" class="btn btn-primary btn-block">Add</button>
      </div>
      <div class="col-6">
        <button v-on:click="remove" class="btn btn-warning btn-block">Remove</button>
      </div>
    </div>
    <transition-group name="list" tag="p" class="segment">
      <span v-for="item in items" v-bind:key="item" class="list-item">
        {{ item }}
      </span>
    </transition-group>
  </div>
</template>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                 SCRIPTS                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<script>
export default {
  name: 'list-transition',
  data () {
    return {
      title: 'List transition',
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10
    }
  },
  created () {
    // console.log('list-transition created')
  },
  methods: {
    randomIndex: function () {
      return Math.floor(Math.random() * this.items.length)
    },
    add: function () {
      this.items.splice(this.randomIndex(), 0, this.nextNum++)
    },
    remove: function () {
      this.items.splice(this.randomIndex(), 1)
    }
  }
}
</script>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                  STYLES                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
</style>



// WEBPACK FOOTER //
// list-transition.vue?4a41360c